import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Dropdown } from "primereact/dropdown";

import { translationKeys } from "../../../../models/app-translation-keys";
import { DropdownLanguageOptions } from "../../../../models/constants/app-language-options.const";
import { ILanguageOption } from "../../../../models/interfaces";
import { useStore } from "../../../../stores/StoreContext";

import "./LanguageSelection.scss";

const LanguageSelectionRaw: FunctionComponent = () => {
  const { t } = useTranslation();
  const { userStore } = useStore();

  const languageSelectionRef = useRef<Dropdown>(null);

  const selectedLanguage: ILanguageOption | undefined = DropdownLanguageOptions.find(
    option => option.code === userStore.currentLanguage.code,
  );

  const handleLanguageSelectButtonChange = (languageOption: ILanguageOption) => {
    userStore.changeLanguage(languageOption);
  };

  const dropdownItemTemplate = (item: ILanguageOption) => (
    <span>{t(translationKeys.language[item.code as keyof typeof translationKeys.language])}</span>
  );

  const dropdownValueTemplate = (item: ILanguageOption | null | undefined) =>
    item ? <span>{item.code?.toUpperCase()}</span> : null;

  return (
    <Dropdown
      ref={languageSelectionRef}
      value={selectedLanguage}
      onChange={event => handleLanguageSelectButtonChange(event.value)}
      options={DropdownLanguageOptions}
      className="language-dropdown plain"
      name="language-dropdown"
      itemTemplate={dropdownItemTemplate}
      valueTemplate={dropdownValueTemplate}
    />
  );
};

export const LanguageSelection = observer(LanguageSelectionRaw);
